import React from 'react';
import { Nav, NavItem } from './NavBar.styles';

const NavBar = props => {
	const { navNo, setNavNumber } = props;
	return (
		<Nav>
			<NavItem active={navNo === 0} onClick={() => setNavNumber(0)}>
				PROGRAM SAVINGS DASHBOARD
			</NavItem>
			<NavItem active={navNo === 1} onClick={() => setNavNumber(1)}>
				VENDOR ELIMINATION REPORT
			</NavItem>
			<NavItem active={navNo === 2} onClick={() => setNavNumber(2)}>
				VENDOR REDUCTION REPORT
			</NavItem>
			<NavItem active={navNo === 3} onClick={() => setNavNumber(3)}>
				GL ACCOUNT FINANCE MASTER
			</NavItem>
			{/* <NavItem active={navNo === 4} onClick={() => setNavNumber(4)}>
				TOTAL PROGRAM ARCHIVE
			</NavItem> */}
		</Nav>
	);
};

export default NavBar;
